<ion-content class="dashboard-customize" [class.clone-machine-content]="isCloneMode">
  <span>
    <button type="button" class="close-icon" (click)="closeModal()" [attr.aria-label]="'Close' | translate">
      <img tooltip="{{'Close' | translate }}" alt="" placement="bottom" src="/assets/icon/cancel.svg">
    </button>
    <div class="title" [class.project-machine-mode-title]="showCloneMachineOption">
      <ion-row *ngIf="showCloneMachineOption" class="machine-create-mode-row">
        <ion-col size="12">
          <ion-radio-group class="machine-create-mode-group" [value]="machineCreationMode" (ionChange)="onMachineCreationModeChange($event)" mode="md">
            <ion-item lines="none" class="machine-create-mode-option">
              <ion-radio slot="start" value="add-machine"></ion-radio>
              <ion-label class="radio-group-labels">{{ 'Add Machine' | translate }}</ion-label>
            </ion-item>
            <ion-item lines="none" class="machine-create-mode-option">
              <ion-radio slot="start" value="clone-machine"></ion-radio>
              <ion-label class="radio-group-labels">{{ 'clone_machine' | translate }}</ion-label>
            </ion-item>
          </ion-radio-group>
        </ion-col>
      </ion-row>
      <span *ngIf="!showCloneMachineOption"> {{ (title ? title : 'Create Machine') | translate }}</span>
    </div>
     
  </span>
  <form class="form-scroll" [class.scrollVertical]="!isCloneMode" [class.clone-form-scroll]="isCloneMode" #infScroller infiniteScroll [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="1000" [scrollWindow]="false" #formEle #addMachine="ngForm" ngNativeValidate
    autocomplete="off">
    <ion-grid class="inp-container" *ngIf="formData">
      <ng-container *ngIf="isCloneMode; else createMachineFields">
        <div class="clone-machine-form">
          <p class="clone-machine-description">{{ 'clone_machine_description' | translate }}</p>
          <p class="clone-machine-description clone-machine-review-message">{{ 'clone_machine_review_message' | translate }}</p>
          <div class="clone-field-row">
            <ion-label>{{ 'machine_name' | translate }} :</ion-label>
            <div class="clone-field-control">
              <ion-item lines="none">
                <ion-input placeholder="{{ 'Enter Machine Name' | translate }}" name="machine_name" required
                  [(ngModel)]="formData.machine_name" #machine_name="ngModel" maxlength="160">
                </ion-input>
              </ion-item>
              <ion-text class="validate-error"
                *ngIf="(machine_name.invalid && machine_name.touched) || (isFormSubmitted && (!formData.machine_name || formData.machine_name.trim() === ''))">
                {{ 'machine_name_required' | translate}}
              </ion-text>
            </div>
          </div>
          <div class="clone-field-row">
            <ion-label>{{ 'Customer_Name' | translate }} :</ion-label>
            <div class="clone-field-control">
              <ng-container *ngIf="isCustomerReadonly; else cloneCustomerSelect">
                <ion-item lines=none class="readonly-field">
                  <ion-input name="customerName" required readonly disabled
                    [(ngModel)]="formData.customerName" #customerName="ngModel"
                    placeholder="{{ 'Customer Name' | translate }}">
                  </ion-input>
                </ion-item>
              </ng-container>
              <ng-template #cloneCustomerSelect>
                <ng-select required dropdownPosition="bottom" class="clone-customer-select placeholder-color"
                  [items]="cloneCustomerList" bindLabel="customer_name" [compareWith]="compareCloneCustomers"
                  name="cloneCustomer" [(ngModel)]="cloneSelectedCustomer" #cloneCustomer="ngModel"
                  [loading]="cloneCustomerLoading" [searchable]="true" [clearable]="true" [typeahead]="cloneCustomerInput$"
                  (change)="onCloneCustomerChange($event)" (clear)="clearCloneCustomer()" (scrollToEnd)="fetchMoreCloneCustomers()"
                  placeholder="{{ 'Select Customer' | translate }}">
                </ng-select>
                <ion-text class="validate-error" *ngIf="cloneCustomer?.invalid || (isFormSubmitted && !formData.customerId)">
                  {{ 'required' | translate}}
                </ion-text>
              </ng-template>
              <input type="hidden" name="customerId" [(ngModel)]="formData.customerId" />
              <input type="hidden" name="cloneCustomerName" [(ngModel)]="formData.customerName" />
              <ion-text class="validate-error"
                *ngIf="isCustomerReadonly && (customerName?.invalid || (isFormSubmitted && (!formData.customerName || formData.customerName.trim() === '' || !formData.customerId)))">
                {{ 'required' | translate}}
              </ion-text>
            </div>
          </div>
          <div class="clone-field-row">
            <ion-label>{{ 'copy_from_machine_id' | translate }} :</ion-label>
            <div class="clone-field-control">
              <ion-item lines=none class="readonly-field">
                <ion-input name="copyFromMachineId" readonly
                  [ngModel]="cloneSourceMachine?.global_Id || cloneSourceMachine?.global_id || cloneSourceMachine?.machine_Id || cloneSourceMachine?.Machine_Id || cloneSourceMachine?.id || ''">
                </ion-input>
              </ion-item>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #createMachineFields>
      <p *ngIf="isProjectAddCloneMode" class="project-clone-description">
        {{ 'select_machine_to_clone_description' | translate }}
      </p>
      <ng-container *ngIf="isProjectAddCloneMode; else standardAddMachineFields">
      <ion-row>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'copy_machine_from_list' | translate }} *</ion-label>
            <ng-select required [items]="projectMachineList" [(ngModel)]="selectedProjectCloneMachine"
              name="projectCloneMachine" #projectCloneMachine="ngModel" class="source-dropdown cust-name-select placeholder-color project-clone-machine-dropdown"
              [searchable]="true" [clearable]="true" [searchFn]="searchProjectMachine" [loading]="projectCloneMachineLoading"
              [notFoundText]="((projectMachineList?.length ? 'No Item Found' : 'machines_not_created_yet_to_clone') | translate)"
              placeholder="{{ 'select_from_project_machine_list' | translate }}" (change)="onProjectCloneMachineChange($event)">
              <ng-template ng-label-tmp let-item="item">
                {{ getProjectMachineName(item) }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ getProjectMachineName(item) }}
              </ng-template>
            </ng-select>
            <ion-text class="validate-error"
              *ngIf="(projectCloneMachine.invalid && projectCloneMachine.touched) || (isFormSubmitted && !selectedProjectCloneMachine)">
              {{ 'required' | translate}}
            </ion-text>
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'new_clone_machine_name' | translate }} *</ion-label>
            <ion-item lines=none>
              <ion-input placeholder="{{ 'Enter Machine Name' | translate }}" name="machine_name" required
                [(ngModel)]="formData.machine_name" #machine_name="ngModel" maxlength="160">
              </ion-input>
            </ion-item>
            <ion-text class="validate-error"
              *ngIf="(machine_name.invalid && machine_name.touched) || (isFormSubmitted && (!formData.machine_name || formData.machine_name.trim() === ''))">
              {{ 'machine_name_required' | translate}}
            </ion-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <div class="each_div"
            [tooltip]="getSelectedOptionsTooltip(selectedMachineMode, sharedValue?.machineModeList, 'name')"
            placement="bottom">
            <ion-label> {{ 'Machine Mode' | translate}} *</ion-label>
            <ng-select required data-field="machineMode" [items]="sharedValue?.machineModeList" bindLabel="name"
              name="cloneMachineMode" [(ngModel)]="selectedMachineMode" [multiple]="true" [selectableGroup]="true"
              [closeOnSelect]="false" [searchable]="true" [disabled]="true"
              class="source-dropdown cust-name-select">
              <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
                <input id="clone-source-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$" />
                {{item.name | translate}}
              </ng-template>
            </ng-select>
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Customer Name' | translate }} *</ion-label>
            <ion-item lines=none class="readonly-field project-clone-disabled-field">
              <ion-input name="customerName" readonly disabled [(ngModel)]="formData.customerName"
                placeholder="{{ 'Customer Name' | translate }}">
              </ion-input>
            </ion-item>
            <input type="hidden" name="customerId" [(ngModel)]="formData.customerId" />
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Machine Type' | translate}} *</ion-label>
            <ng-select placeholder="{{ 'Select Machine Type' | translate}}" class="placeholder-color"
              data-field="machineType" name="cloneMachineType" [(ngModel)]="formData.machineType" [disabled]="true">
              <ng-option *ngFor="let item of machineTypeList" [value]="item.id">{{item.machine_type}}</ng-option>
            </ng-select>
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Application' | translate}} *</ion-label>
            <ng-select placeholder="{{ 'Select Application' | translate}}" class="placeholder-color"
              data-field="application" name="cloneApplication" [(ngModel)]="formData.application" [disabled]="true">
              <ng-option *ngFor="let item of applicationList" [value]="item.id">{{item.application}}</ng-option>
            </ng-select>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <div class="each_div"
            [tooltip]="getSelectedOptionsTooltip(formData.controlSystem, controlSystemList, 'control_system')"
            placement="top">
            <ion-label> {{ 'Control System' | translate}} *</ion-label>
            <ng-select data-field="controlSystem" name="cloneControlSystem"
              [(ngModel)]="formData.controlSystem" class="multi-select multi-select-bg placeholder-color" [items]="controlSystemList"
              bindLabel="control_system" bindValue="id" [multiple]="true" [selectableGroup]="true" [closeOnSelect]="false"
              [searchable]="true" [disabled]="true">
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="clone-control-system-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected" />
                {{item.control_system}}
              </ng-template>
            </ng-select>
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="each_div"
            [tooltip]="getSelectedOptionsTooltip(formData.features, featureList, 'specific_feature')"
            placement="top">
            <ion-label> {{ 'Specific Feature' | translate}} *</ion-label>
            <ng-select data-field="features" name="cloneFeatures"
              [(ngModel)]="formData.features" class="multi-select multi-select-bg placeholder-color" [items]="featureList"
              bindLabel="specific_feature" bindValue="id" [multiple]="true" [selectableGroup]="true" [closeOnSelect]="false"
              [searchable]="true" [disabled]="true">
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="clone-feature-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected" />
                {{item.specific_feature}}
              </ng-template>
            </ng-select>
          </div>
        </ion-col>
      </ion-row>
      </ng-container>
      <ng-template #standardAddMachineFields>
      <ion-row>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Machine Name' | translate }} *</ion-label>
            <ion-item lines=none>
              <ion-input placeholder="{{ 'Enter Machine Name' | translate }}" name="machine_name" required
                [(ngModel)]="formData.machine_name" #machine_name="ngModel" maxlength="160">
              </ion-input>
            </ion-item>
            <ion-text class="validate-error"
              *ngIf="(machine_name.invalid && machine_name.touched) || (isFormSubmitted && (!formData.machine_name || formData.machine_name.trim() === ''))">
              {{ 'machine_name_required' | translate}}
            </ion-text>
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Machine Mode' | translate}} *</ion-label>
            <ng-select
              required
              data-field="machineMode"
              [items]="sharedValue?.machineModeList"
              bindLabel="name"
              #machineMode="ngModel"
              name="machineMode"
              [(ngModel)]="selectedMachineMode"
              [multiple]="true"
              [selectableGroup]="true"
              [closeOnSelect]="false"
              [searchable]="true"
              placeholder="{{'enter_machine_mode' | translate}}"
              class="source-dropdown cust-name-select">
              <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
                <input id="source-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$" />
                {{item.name | translate}}
              </ng-template>
            </ng-select>
            <ion-text class="validate-error" *ngIf="machineMode.invalid && machineMode.touched">
              {{ 'required' | translate}}
            </ion-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Customer Name' | translate }} *</ion-label>
            <div> 
              <ng-select *ngIf="!isCustomerReadonly"
                required [loading]="formData.customerLoading" dropdownPosition="bottom"
                data-field="customerName"
                class="cust-name-select placeholder-color" [typeahead]="contactInput$" [bindValue]="'customer_name'"
                (change)="customerSearchByErpId($event)" [bindLabel]="'customer_name'" name="customerName"
                [clearable]="true" [items]="contactList | async" [(ngModel)]="formData.customerName"
                #customerName="ngModel" placeholder="{{ 'Search Customer Name' | translate }}">
              </ng-select>
              <ion-item *ngIf="isCustomerReadonly" lines=none class="readonly-field">
                <ion-input name="customerName" required readonly
                  [(ngModel)]="formData.customerName" #customerName="ngModel"
                  placeholder="{{ 'Customer Name' | translate }}">
                </ion-input>
              </ion-item>
              <input type="hidden" name="customerId" [(ngModel)]="formData.customerId" #customerId="ngModel" />
              <ion-text class="validate-error"
                *ngIf="(customerName?.invalid && customerName?.touched) || (isFormSubmitted && (!formData.customerName || formData.customerName.trim() === '' || !formData.customerId))">
                {{ 'required' | translate}}
              </ion-text>
            </div>
          </div>
        </ion-col>
        <!-- <ion-col size="6" *ngIf="formData.customerName && formData.industrySegment">
          <div class="each_div">
            <ion-label> {{ 'Industry Code' | translate }}</ion-label>
            <ion-item lines=none>
              <ion-input readonly [disabled]="true" [value]="formData?.industrySegment">
              </ion-input>
            </ion-item>
            <input type="hidden" name="industrySegment" [(ngModel)]="formData.industrySegment"
              #industrySegment="ngModel" />
          </div>
        </ion-col> -->
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Machine Type' | translate}} *</ion-label>
            <ng-select placeholder="{{ 'Select Machine Type' | translate}}" class="placeholder-color"
              data-field="machineType" name="machineType" [(ngModel)]="formData.machineType"
              (change)="setMachineType($event)" (scrollToEnd)="fetchMoreMachineType()" [virtualScroll]='true' [clearable]="true">
              <ng-option *ngFor="let item of machineTypeList" [value]="item.id">{{item.machine_type}}</ng-option>
            </ng-select>
            <ion-text class="validate-error" *ngIf="isFormSubmitted && !formData.machineType">
              {{ 'required' | translate}}
            </ion-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Application' | translate}} *</ion-label>
            <ng-select placeholder="{{ 'Select Application' | translate}}" class="placeholder-color"
              data-field="application" name="application" [(ngModel)]="formData.application"
              (change)="setApplication($event)" (scrollToEnd)="fetchMoreApplication()" [virtualScroll]='true' [clearable]="true">
              <ng-option *ngFor="let item of applicationList" [value]="item.id">{{item.application}}</ng-option>
            </ng-select>
            <ion-text class="validate-error" *ngIf="isFormSubmitted && !formData.application">
              {{ 'required' | translate}}
            </ion-text>
          </div>
        </ion-col>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Control System' | translate}} *</ion-label>
            <ng-select placeholder="{{ 'Select Control System' | translate}}"
              data-field="controlSystem" name="controlSystem" [(ngModel)]="formData.controlSystem"
              class="multi-select multi-select-bg placeholder-color" 
              [items]="controlSystemList"
              bindLabel="control_system"
              bindValue="id"
              [multiple]="true" 
              [selectableGroup]="true"
              [closeOnSelect]="false"
              [searchable]="true"
              (change)="setControlSystem($event)" 
              #controlSystem 
              (add)="removeControlSystemFocus($event)" 
              (scrollToEnd)="fetchMoreControlSystem()" 
              [virtualScroll]='true' 
              [clearable]="true">
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="control-system-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected" />
                {{item.control_system}}
              </ng-template>
            </ng-select>
            <ion-text class="validate-error" *ngIf="isFormSubmitted && !formData.controlSystem.length">
              {{ 'required' | translate}}
            </ion-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <div class="each_div">
            <ion-label> {{ 'Specific Feature' | translate}} *</ion-label>
            <ng-select placeholder="{{ 'Select Features' | translate}}"
              data-field="features" name="features" [(ngModel)]="formData.features"
              class="multi-select multi-select-bg placeholder-color" 
              [items]="featureList"
              bindLabel="specific_feature"
              bindValue="id"
              [multiple]="true" 
              [selectableGroup]="true"
              [closeOnSelect]="false"
              [searchable]="true"
              (change)="setFeature($event)" 
              #feature 
              (add)="removeFeatureFocus($event)" 
              (scrollToEnd)="fetchMoreFeature()" 
              [virtualScroll]='true' 
              [clearable]="true">
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="feature-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$.selected" />
                {{item.specific_feature}}
              </ng-template>
            </ng-select>
            <ion-text class="validate-error" *ngIf="isFormSubmitted && !formData.features.length">
              {{ 'required' | translate}}
            </ion-text>
          </div>
        </ion-col>
      </ion-row>
      </ng-template>
      </ng-template>
    </ion-grid>
  </form>
  <ion-row *ngIf="!isCloneMode">
    <ion-col class="button-col">
      <ng-container *ngIf="isProjectAddCloneMode; else standardActionButtons">
         <ion-button class="app-btn save-btn" shape="round" fill="outline" color="primary" (click)="onSubmit(addMachine)">
          {{ 'proceed' | translate }}
        </ion-button>
        <ion-button class="app-btn cancel-btn" shape="round" fill="outline" color="primary" (click)="closeModal()">
          {{'Cancel'|translate}}
        </ion-button>
      </ng-container>
      <ng-template #standardActionButtons>
        <ion-button class="app-btn save-btn" shape="round" fill="outline" color="primary" (click)="onSubmit(addMachine)">
          {{ 'Submit' | translate }}
        </ion-button>
        <ion-button class="app-btn cancel-btn" shape="round" fill="outline" color="primary" (click)="closeModal()">
          {{'Cancel'|translate}}
        </ion-button>
      </ng-template>
    </ion-col>
  </ion-row>
</ion-content>
<ion-footer *ngIf="isCloneMode" class="clone-actions-footer ion-no-border">
  <ion-row class="clone-action-row">
    <ion-col class="button-col">
      <ion-button class="app-btn cancel-btn" shape="round" fill="outline" color="primary" (click)="closeModal()">
        {{'Cancel'|translate}}
      </ion-button>
      <ion-button class="app-btn save-btn" shape="round" fill="outline" color="primary" (click)="onSubmit(addMachine)">
        {{ 'proceed' | translate }}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>